export const extensionsEditDocs = [
  'djvu',
  'doc',
  'docm',
  'docx',
  'docxf',
  'dot',
  'dotm',
  'dotx',
  'epub',
  'fb2',
  'fodt',
  'htm',
  'html',
  'mht',
  'mhtml',
  'odt',
  'ott',
  'oxps',
  'rtf',
  'stw',
  'sxw',
  'txt',
  'wps',
  'wpt',
  'xml',
  'xps',
]
export const extensionsEditCell = [
  'csv',
  'et',
  'ett',
  'fods',
  'ods',
  'ots',
  'sxc',
  'xls',
  'xlsb',
  'xlsm',
  'xlsx',
  'xlt',
  'xltm',
  'xltx',
]
export const extensionsEditPresentation = [
  'dps',
  'dpt',
  'fodp',
  'odp',
  'otp',
  'pot',
  'potm',
  'potx',
  'pps',
  'ppsm',
  'ppsx',
  'ppt',
  'pptm',
  'pptx',
  'sxi',
]
export const extensionsEditable = [
  ...extensionsEditDocs,
  ...extensionsEditCell,
  ...extensionsEditPresentation,
]
export const extensionsImages = ['png', 'jpg', 'jpeg', 'tiff', 'gif', 'webp', 'bmp']
export const extensionsDocs = ['pdf', ...extensionsEditable]
export const extensions = [...extensionsDocs, ...extensionsImages]

type Upload = Record<string, unknown> & {
  filename?: string
  basename?: string
  name?: string
  extension?: string
  mime_type?: string
  secure_filename?: string
  versions?: unknown[]
}

type OfficeFileType = 'word' | 'cell' | 'slide'
type EditorConfig = {
  documentType: OfficeFileType
  fileType: string // file extension no ".", e.g. "pdf"
}

export function getEditorConfig(upload: Upload): EditorConfig | undefined {
  let fileType = getExtension(upload)
  if (!fileType) {
    return
  }

  const dtmap: Record<'word' | 'cell' | 'slide', string[]> = {
    word: extensionsEditDocs,
    cell: extensionsEditCell,
    slide: extensionsEditPresentation,
  }

  for (const [_documentType, extensionsList] of Object.entries(dtmap)) {
    if (extensionsList.includes(fileType)) {
      let documentType = _documentType as OfficeFileType
      return { documentType, fileType }
    }
  }
}

/**
 * Расширение файла для просмотрщика.
 * Старые upload'ы иногда теряют точку в secure_filename (`hash_pdf`);
 * в Finder приходит basename/name/extension/mime_type без поля filename.
 */
export function getExtension(upload: Upload): string | undefined {
  const names = [
    upload?.filename,
    upload?.basename,
    upload?.name,
    upload?.secure_filename,
  ]
  for (const raw of names) {
    const filename = String(raw || '').trim()
    if (!filename) {
      continue
    }
    const lowered = filename.toLowerCase()
    // После secure_filename на кириллице точка могла стать `_` (`…_pdf`).
    if (lowered.endsWith('_pdf') || lowered.endsWith('.restricted.pdf')) {
      return 'pdf'
    }
    if (!filename.includes('.')) {
      continue
    }
    const ext = filename.split('.').pop()?.toLowerCase()
    if (ext) {
      return ext
    }
  }
  const fromField = String(upload?.extension || '')
    .trim()
    .replace(/^\./, '')
    .toLowerCase()
  if (fromField) {
    return fromField
  }
  const mime = String(upload?.mime_type || '').toLowerCase()
  if (mime.includes('pdf')) {
    return 'pdf'
  }
  return undefined
}

/** PDF для защиты скачивания (ключ), в т.ч. старые/finder payload'ы. */
export function isPdfUpload(upload: Upload): boolean {
  return getExtension(upload) === 'pdf'
}

export function isAcceptable(upload: Upload) {
  const ext = getExtension(upload)
  if (!ext) {
    return false
  }
  return extensions.includes(ext)
}

export function hasVersions(upload: Upload) {
  return Array.isArray(upload?.versions) && upload.versions.length > 0
}
